import { api } from "../../App/services/api";
function getFaqsExternal() {
    return api.get("/faq/support");
}
export default {
    getFaqsExternal: getFaqsExternal
};
